<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <wfh-responsibility>
        </wfh-responsibility> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import wfhResponsibility from './todo-wfh-responsibility'
export default {
    components: {
        wfhResponsibility
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-wfh-responsibility.vue